import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./index.css";
import * as XLSX from "xlsx";
import { Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../context/LoaderContext";
import NpaListSection from "./ListSection";
import NpaAddImpExprtBtn from "./FilterPanel";
import {
  importUserList,
  reqToImportNpaProperties,
} from "../../redux/slice/propertiesSlice";
import DeletePopup from "../../components/delete-popup";
import {
  ArrowLeftIcon,
  CoAuthorityIcon,
  NagarpalikaIcon,
  RuralAgriIcon,
  RuralIcon,
} from "../../assets/icons";
import {
  deleteAllProperty,
  npaAllProperties,
} from "../../redux/slice/allPropertiesSlice";
// import { fetchPropertyFields } from "../../../redux/slice/fieldsSlice";
// import AddTpFileModal from "../../Map/DP";
import {
  createJantriFile,
  createJantriLocation,
  fetchJantriLocations,
  truncateNavStack,
  updateJantriFile,
  updateJantriLocation,
  setNavStack,
  resetJantriNavigation,
} from "../../redux/slice/jantriSlice";
import AddStateModal from "../Map/AddStateModal";
import { useToast } from "../../context/TostContext";
import { TabCard } from "../../components/custom-card/Cards";
import ImportModal from "../../components/modals/ImportModal";

// import { allUserList } from "../../redux/slice/userSlice";

export default function JantriModule() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { type } = useParams();
  const { setLoading } = useLoader();
  const toast = useToast();
  // List Dropdown
  const [openDropdown, setOpenDropdown] = useState(null);
  // Pagination

  const [openDeletePropertyModal, setOpenDeletePropertyModal] = useState(false);
  const [selectedDeleteProperty, setSelectedDeleteProperty] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  // Card Status
  const DEFAULT_STATUS = ""; // empty string = All Property

  // 2) Use it for initial state
  const [cardStatus, setCardStatus] = useState(DEFAULT_STATUS);
  // Add or Edit Form
  const [isEdit, setIsEdit] = useState(false);

  // search & Filter
  const [filterValues, setFilterValues] = useState({
    search: "",
    asset: "",
    property: [],
    possession: [],
    city: "",
    reservePrice: "",
    transaction: [],
    status: "",
    land_types: "",
  });
  // Open Modal for Import
  const [openImportModal, setOpenImportModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const searchTimeout = useRef(null);
  const [showJantriModal, setShowJantriModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // const [searchQuery, setSearchQuery] = useState("");  // Search query  // console.log("csvData",csvData);
  // Options for filters dropdown

  //  const [dropdownData, setDropdownData] = useState({
  //     propertyTypes: [],
  //     assetCategories: [],
  //     possessionTypes: [],
  //     auctionTypes: [],
  //   });

  // console.log("dropdownData",dropdownData);
  // console.log("cardStatus",cardStatus);

  const jantriTypes = useSelector((state) => state.jantri.list);
  const { jantriList = [], isLoading } = useSelector((state) => state.jantri);
  console.log("isLoading", isLoading);
  console.log("jantriList", jantriList);

  const nextLabel =
    jantriList?.next_level_label?.charAt(0).toUpperCase() +
    jantriList?.next_level_label?.slice(1);

  const navStack = useSelector((state) => state.jantri.navStack);

  // const pagination = jantriList?.pagination;
  const totalJantri = jantriList?.pagination?.total;
  const [limit, setLimit] = useState({ value: 10, label: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const count = jantriList?.count;

  const paginationConfig = useMemo(() => ({
    currentPage,
    totalPages: Math.ceil(totalJantri / limit?.value) || 1,
    total: totalJantri || 0,
    onPageChange: (page) => setCurrentPage(page),
    pageSize: limit?.value,
    setPageSize: (size) => setLimit({ value: size, label: size }),
    setCurrentPage
  }), [currentPage, totalJantri, limit]);

  const currentJantriType = useMemo(() => {
    return jantriTypes.find(
      (m) => m.code.toLowerCase() === type?.toLowerCase(),
    );
  }, [jantriTypes, type]);

  const jantriTypeId = currentJantriType?.id;

  const headerPortalTarget = document.getElementById("header-portal-target");

  const jantriName = useMemo(() => {
    if (!currentJantriType?.code) return "";
    switch (currentJantriType.code.toLowerCase()) {
      case "coauthority":
        return "Co/Authority";
      case "nagarpalika":
        return "Nagarpalika";
      case "rural_agri":
        return "Rural Agri";
      case "rural_na":
        return "Rural NA";
      default:
        return currentJantriType.code;
    }
  }, [currentJantriType]);

  const headerContent = (
    <div className="d-flex align-items-center justify-content-between w-100">
      <h4 className="fw-semibold mb-0 text-primary fs-lg">
        <span className="text-muted fw-normal">Jantri / </span>{jantriName}
      </h4>
    </div>
  );

  // useEffect(() => {
  //   dispatch(fetchPropertyFields()); // Fetch the dropdown fields when the component mounts
  // }, [dispatch]);




  // const cityOption = propertyFields.property.city.map((city) => ({
  //   value: city,
  //   label: city,
  // }));

  // const {users = []} = useSelector((state) => state?.user?.allUser?.data || {});

  const importModalUsersList = useSelector(
    (state) => state?.property?.importBankUsers?.data || [],
  );

  const importModalUsers = importModalUsersList?.map((user) => ({
    id: user?.id,
    value: user?.id,
    label: user?.profile?.name,
    bankName: user?.profile?.bank?.bank_name,
    branchName: user?.profile?.branch?.branch_name,
    city: user?.profile?.branch?.branch_city,
  }));



  // initialize from sessionStorage if present (fallback to 10)

  useEffect(() => {
    if (currentJantriType?.id && !isInitialLoad) {
      const stateToSave = {
        parentId: jantriList?.parent_id || null,
        navStack: navStack
      };
      sessionStorage.setItem(`jantri_state_${type}`, JSON.stringify(stateToSave));
    }
  }, [jantriList?.parent_id, navStack, type, currentJantriType?.id, isInitialLoad]);

  useEffect(() => {
    if (!jantriTypeId) return;

    let targetParentId = jantriList?.parent_id || null;

    if (isInitialLoad) {
      setLoading(true);
      const savedState = sessionStorage.getItem(`jantri_state_${type}`);
      if (savedState) {
        try {
          const { parentId, navStack: savedNavStack } = JSON.parse(savedState);
          targetParentId = parentId;
          dispatch(setNavStack(savedNavStack));
        } catch (e) {
          console.error("Failed to parse saved jantri state", e);
        }
      }
    }

    dispatch(
      fetchJantriLocations({
        jantri_type_id: currentJantriType.id,
        parent_id: targetParentId,
        page: currentPage,
        limit: limit?.value,
        search: filterValues?.search || "",
        direction: "forward",
        mode: filterValues?.search ? "search" : "auto",
      }),
    ).finally(() => {
      if (isInitialLoad) {
        setLoading(false);
        setIsInitialLoad(false);
      }
    });
  }, [
    dispatch,
    currentJantriType?.id,
    currentPage,
    limit?.value,
    filterValues?.search,
    jantriTypeId,
    type,
    jantriList?.parent_id,
    isInitialLoad,
    setLoading,
  ]);

  useEffect(() => {
    setSearchQuery("");
    setCurrentPage(1);
    setIsInitialLoad(true);
    dispatch(resetJantriNavigation());
  }, [type, dispatch]);

  const title =
    currentJantriType?.code === "coauthority"
      ? "Total Co/Authority"
      : currentJantriType?.code === "nagarpalika"
        ? "Total Nagarpalika"
        : currentJantriType?.code === "rural_agri"
          ? "Total Rural Agri"
          : currentJantriType?.code === "rural_na"
            ? "Total Rural NA"
            : "";
  const NpaPropertiesCard = [
    {
      id: 1,
      total: count || 0,
      title,
      icon:
        currentJantriType?.code === "coauthority"
          ? <CoAuthorityIcon size={24} />
          : currentJantriType?.code === "nagarpalika"
            ? <NagarpalikaIcon size={24} />
            : currentJantriType?.code === "rural_agri"
              ? <RuralAgriIcon size={24} />
              : currentJantriType?.code === "rural_na"
                ? <RuralIcon size={24} />
                : "",
      status: DEFAULT_STATUS,
    },
    // {
    //   id: 2,
    //   total: counts?.total_public_properties || 0,
    //   title: "Public Property",
    //   src: PublicProperty,
    //   status: "public",
    // },
  ];

  const handleCardClick = (status) => {
    setCardStatus(status);
    setCurrentPage(1);
  };
  // const searchTimeout = useRef(null); // To store the timeout ID

  // Debounced Search Handler
  // const handleSearch = useCallback(() => {
  //   if (!searchQuery) {
  //     // Do not call API if searchQuery is empty
  //     return;
  //   }

  //   if (searchTimeout.current) {
  //     clearTimeout(searchTimeout.current); // Clear the previous timeout if the user is still typing
  //   }

  //   searchTimeout.current = setTimeout(() => {
  //     console.log("gauravss");

  //     dispatch(npaAllProperties({
  //       search: filterValues?.search,
  //       page: currentPage,
  //       limit: limit?.value,
  //       status: cardStatus,
  //       asset_category: filterValues?.asset,
  //       property_type: filterValues?.property,
  //       possession_type: filterValues?.possession,
  //       city_town: filterValues?.city,
  //       reserve_price: filterValues?.reservePrice,
  //     }));
  //   }, 1000); // 1000ms delay to wait before calling API
  // }, [filterValues, cardStatus, currentPage, searchQuery, dispatch, limit?.value]);

  // // Trigger the API call whenever filterValues or searchQuery changes
  // useEffect(() => {
  //   if (searchQuery) {
  //     handleSearch();
  //   }
  //   return () => clearTimeout(searchTimeout.current); // Clean up timeout on unmount or change
  // }, [handleSearch, searchQuery]);

  // A ref to hold the debounce timer

  // Debounce effect
  useEffect(() => {
    if (searchQuery === "") {
      setFilterValues((prev) => ({ ...prev, search: "" }));
      return;
    }

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setFilterValues((prev) => ({
        ...prev,
        search: searchQuery,
      }));
    }, 500);

    return () => clearTimeout(searchTimeout.current);
  }, [searchQuery]);

  console.log(filterValues, "filterValues");
  // useEffect(() => {
  //   dispatch(reqToGetFilterData({}));
  //   dispatch(propertyTypesDropdown({})).then((res) => {
  //     if (res?.payload?.success === true) {
  //       const formattedData = {
  //         propertyTypes: res?.payload?.data?.propertyTypes?.map(item => item?.name),
  //         assetCategories: res?.payload?.data?.assetCategories?.map(item => item?.name),
  //         possessionTypes: res?.payload?.data?.possessionTypes?.map(item => item?.name),
  //         auctionTypes: res?.payload?.data?.auctionTypes.map(item => item?.name),
  //       };
  //       setDropdownData(formattedData);
  //     }
  //   });
  // }, [dispatch]);

  const handleToggleDropdown = (dropdownId) => {
    setOpenDropdown((prev) => (prev === dropdownId ? null : dropdownId));
  };


  const getCustomerActions = (item) => [
    {
      title: "Delete",
      handler: () => handlerDeleteProperty(item),
    },
  ];

  const handlerDeleteProperty = (item) => {
    setSelectedDeleteProperty(item);
    setOpenDeletePropertyModal(true);
  };

  // Main Handler for Deleting NPA Properties
  const handleConfirmDelete = () => {
    try {
      setLoading(true);
      setIsSubmitting(true);
      dispatch(deleteAllProperty({ id: selectedDeleteProperty?.id })).then(
        (res) => {
          toast.success(res?.msg || "Property deleted successfully");
          setOpenDeletePropertyModal(false);
          dispatch(npaAllProperties({})).then((res) => {
            setLoading(false);
          });
        },
      );
    } catch (error) {
      toast.error(error?.msg || "Failed to delete Property");
      setLoading(false);
    } finally {
      setIsSubmitting(false);
      setOpenDeletePropertyModal(false);
    }
  };

  const handleEditBtn = (item) => {
    setIsEdit(true);
    navigate(`/broker-crm/properties/edit/${item.id}`, {
      state: { item, isEdit: true },
    });
  };

  // Handler for Exporting NPA Properties
  const handleExportNpaProperties = () => {
    try {
      setLoading(true);
      dispatch(
        npaAllProperties({
          search: filterValues?.search,
          page: currentPage,
          status: cardStatus,
          asset_category: filterValues?.asset,
          property_type: filterValues?.property,
          possession_type: filterValues?.possession,
          transaction_type: filterValues?.transaction,
          city_town: filterValues?.city,
          reserve_price: filterValues?.reservePrice,
          limit: 100000,
        }),
      ).then((res) => {
        const data = res?.payload?.properties;

        // console.log("data",data);

        if (!data || data.length === 0) {
          toast.error("No data available to Export");
          setLoading(false);
          return;
        }

        // Map the data for export
        const dataToExport = data?.map((item) => {
          return {
            borrower_names: item?.borrower_names || "-",
            property_type: item?.propertyType?.name || "-",
            asset_category: item?.assetCategory?.name || "-",
            land_area: item?.land_area || "-",
            builtup_carpet_area: item?.builtup_carpet_area || "-",
            dsc_required:
              item?.dsc_required === true
                ? "Yes"
                : item?.dsc_required === false
                  ? "No"
                  : "-",
            possession_type: item?.possessionType?.name || "-",
            auction_start_time: item?.auction_start_time
              ? new Date(item.auction_start_time).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
              : "-",
            auction_end_time: item?.auction_end_time
              ? new Date(item.auction_end_time).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
              : "-",
            property_inspection_datetime: item?.property_inspection_datetime
              ? new Date(item.property_inspection_datetime).toLocaleString(
                "en-IN",
                {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                },
              )
              : "-",
            auction_type: item?.auctionType?.name || "-",
            application_submission_date: item?.application_submission_date
              ? new Date(item.application_submission_date).toLocaleString(
                "en-IN",
                {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                },
              )
              : "-",
            time_extension: item?.time_extension || "-",
            property_address: item?.property_address || "-",
            area_locality: item?.area_locality || "-",
            taluka: item?.taluka || "-",
            city_town: item?.city_town || "-",
            province_state: item?.province_state || "-",
            country: item?.country || "-",
            service_provider: item?.service_provider || "-",
            description: item?.description || "-",
            bank_name: item?.Bank?.bank_name || "-",
            branch_name: item?.Branch?.branch_name || "-",
            emd: item?.emd || "-",
            reserve_price: item?.reserve_price || "-",
            min_increment: item?.min_increment || "-",
            amount_outstanding: item?.amount_outstanding || "-",
            contact_name: item?.contact_name || "-",
            contact_number: item?.contact_number || "-",
          };
        });

        // Export to Excel
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "NPA Properties");
        const fileName = "NPA Properties(Admin).xlsx";
        XLSX.writeFile(workbook, fileName);
        setLoading(false);
        dispatch(
          npaAllProperties({
            search: filterValues?.search,
            page: currentPage,
            status: cardStatus,
            asset_category: filterValues?.asset,
            property_type: filterValues?.property,
            possession_type: filterValues?.possession,
            transaction_type: filterValues?.transaction,
            city_town: filterValues?.city,
            reserve_price: filterValues?.reservePrice,
            limit: 10,
          }),
        );
      });
    } catch (error) {
      console.error("Error exporting data: ", error);
      toast.error("Error exporting data: ", error);
      setLoading(false); // Disable loading state on error
    }
  };

  // const downloadSampleCsvFile = async (e) => {
  //   e.preventDefault(); // Prevent default event behavior
  //   setLoading(true);

  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Sample");

  //   ✅ Dynamic dropdown values
  //   const optionsPropertyTypes = ["Select", ...dropdownData.propertyTypes];
  //   const optionsAssetCategories = ["Select", ...dropdownData.assetCategories];
  //   const optionsPossessionTypes = ["Select", ...dropdownData.possessionTypes];
  //   const optionsAuctionTypes = ["Select", ...dropdownData.auctionTypes];

  //   // ✅ Define headers
  //   const headers = [
  //     "asset_category", "property_type", "property_address", "province_state", "taluka", "city_town",
  //     "area_locality", "land_area", "builtup_carpet_area", "borrower_names", "possession_type",
  //     "reserve_price", "emd", "min_increment", "amount_outstanding", "dsc_required", "auction_type",
  //     "auction_start_time", "auction_end_time", "description", "country", "contact_name",
  //     "contact_number", "time_extension", "application_submission_date", "property_inspection_datetime",
  //     "service_provider"
  //   ];

  //   // ✅ Add headers to the worksheet
  //   worksheet.addRow(headers);

  //   // ✅ Set column widths for better visibility
  //   worksheet.columns = headers.map(header => ({ header, key: header, width: 25 }));

  //   // ✅ Static values for other columns
  //   const staticValues = {
  //     property_address: "123 Main St",
  //     province_state: "Gujarat",
  //     taluka: "Varacha",
  //     city_town: "Surat",
  //     area_locality: "Katargam",
  //     land_area: "2000.00",
  //     builtup_carpet_area: "1500.00",
  //     borrower_names: "John Doe",
  //     reserve_price: "5000000.00",
  //     emd: "5000000.00",
  //     min_increment: "6000000.00",
  //     amount_outstanding: "8000000.00",
  //     dsc_required: "No",
  //     auction_start_time: "01/01/2025, 05:30 am",
  //     auction_end_time: "05/01/2020, 05:30 am",
  //     description: "Spacious house 3Bhk",
  //     country: "India",
  //     contact_name: "Manish Mehta",
  //     contact_number: "1234567890",
  //     time_extension: "10 min",
  //     application_submission_date: "06/01/2025, 05:30 am",
  //     property_inspection_datetime: "10/01/2025, 05:30 am",
  //     service_provider: "Mehta and Sons",
  //   };

  //   // ✅ Apply dropdowns & static values (Rows 2 to 10 only)
  //   for (let rowIndex = 2; rowIndex <= 10; rowIndex++) {
  //     const rowData = [];

  //     headers.forEach((header, index) => {
  //       if (header === "asset_category") {
  //         rowData[index] = "Select"; // Dropdown
  //       } else if (header === "property_type") {
  //         rowData[index] = "Select"; // Dropdown
  //       } else if (header === "possession_type") {
  //         rowData[index] = "Select"; // Dropdown
  //       } else if (header === "auction_type") {
  //         rowData[index] = "Select"; // Dropdown
  //       } else {
  //         rowData[index] = staticValues[header] || ""; // Static value
  //       }
  //     });

  //     worksheet.addRow(rowData);

  //     // ✅ Apply dropdown validation
  //     const assetCategoryCell = worksheet.getCell(`A${rowIndex}`);
  //     const propertyTypeCell = worksheet.getCell(`B${rowIndex}`);
  //     const possessionTypeCell = worksheet.getCell(`K${rowIndex}`);
  //     const auctionTypeCell = worksheet.getCell(`Q${rowIndex}`);

  //     assetCategoryCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${optionsAssetCategories.join(",")}"`],
  //     };
  //     propertyTypeCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${optionsPropertyTypes.join(",")}"`],
  //     };
  //     possessionTypeCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${optionsPossessionTypes.join(",")}"`],
  //     };
  //     auctionTypeCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${optionsAuctionTypes.join(",")}"`],
  //     };

  //     // ✅ Apply styling for better visibility
  //     [assetCategoryCell, propertyTypeCell, possessionTypeCell, auctionTypeCell].forEach(cell => {
  //       cell.fill = {
  //         type: "pattern",
  //         pattern: "solid",
  //         fgColor: { argb: "FFFFFF" }, // Light background
  //       };
  //       cell.border = {
  //         top: { style: "thin" },
  //         left: { style: "thin" },
  //         bottom: { style: "thin" },
  //         right: { style: "thin" },
  //       };
  //       cell.font = { bold: true, size: 12 };
  //     });
  //   }

  //   // ✅ Apply header styling
  //   worksheet.getRow(1).eachCell(cell => {
  //     cell.font = { bold: true, color: { argb: "000000" } };
  //     cell.fill = {
  //       type: "pattern",
  //       pattern: "solid",
  //       fgColor: { argb: "FFD3D3D3" }, // Light gray background
  //     };
  //     cell.alignment = { horizontal: "center" };
  //   });

  //   // ✅ Generate and download Excel file
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(blob, "SampleTemplate.xlsx");

  //   setLoading(false);
  // };

  // Import Btn Handler
  const importBtnHandler = () => {
    setOpenImportModal(true);
    dispatch(importUserList({ limit: 1000000 }));
  };

  // close Import Modal
  const handleImportSubmit = async (file, userId) => {
    const formData = new FormData();
    formData.append("properties_file", file);
    formData.append("assigned_to", userId);
    setLoading(true);
    try {
      const result = await dispatch(
        reqToImportNpaProperties({ data: formData }),
      ).unwrap();
      if (result) {
        toast.success(
          result?.msg || "Properties Imported Successfully!",
        );
        dispatch(
          npaAllProperties({
            status: cardStatus,
            page: currentPage,
            limit: limit?.value,
            asset_category: filterValues?.asset,
            property_type: filterValues?.property,
            possession_type: filterValues?.possession,
            city_town: filterValues?.city,
            reserve_price: filterValues?.reservePrice,
            land_types: filterValues?.land_types,
          }),
        );
      }
    } catch (error) {
      let message = error?.message || "Failed to import properties";
      if (error?.data?.errors?.length) {
        const rowErrors = error.data.errors
          .map((e) => `Row ${e.row}: ${e.errors.join(", ")}`)
          .join("\n");
        message = `${message}\n${rowErrors}`;
      }
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  };

  const breadcrumbs = useMemo(() => {
    return navStack.map((item) => ({
      id: item?.parent_id,
      label: item?.label,
    }));
  }, [navStack]);

  const handleBreadcrumbClick = (index) => {
    const parent_id = index === 0 ? null : breadcrumbs[index - 1].id;

    dispatch(truncateNavStack(index - 1));

    dispatch(
      fetchJantriLocations({
        jantri_type_id: currentJantriType.id,
        parent_id,
        page: 1,
        limit: limit?.value,
        direction: "back",
        mode: "navigate",
        search: "",
      }),
    );

    setSearchQuery("");
  };

  const isFileLevel = jantriList?.type === "files";


  return (
    <>
      {headerPortalTarget && createPortal(headerContent, headerPortalTarget)}

      <Container fluid className="px-0">
        <div className="grid gap-4">
          {NpaPropertiesCard?.map((item, i) => (
            <TabCard
              key={i}
              className="g-col-4 g-col-xxl-3"
              count={item?.total}
              title={item?.title}
              icon={item?.icon}
              alt={item?.title}
              active={item.status === cardStatus}
              iconClassName="icon-secondary"
              onClick={() => handleCardClick(item.status)}
            />
          ))}
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
          <div className="px-3 pt-2">
            <div className="jantri-breadcrumb">
              {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={`${crumb.id}-${index}`}>
                  <div className="breadcrumb-item">
                    <button
                      className="breadcrumb-label border-0 bg-transparent p-0 text-capitalize"
                      onClick={() => handleBreadcrumbClick(index)}
                    >
                      {crumb.label}
                    </button>
                  </div>

                  <i className="breadcrumb-separator">
                    <ArrowLeftIcon
                      width={20}
                      height={20}
                      className="rotate-180"
                    />
                  </i>
                </React.Fragment>
              ))}

              {/* Active / last breadcrumb */}
              <div className="breadcrumb-item">
                <span className="breadcrumb-label active text-capitalize">
                  {jantriList?.next_level_label || "File"}
                </span>
              </div>
            </div>
          </div>
          <NpaAddImpExprtBtn
            navigate={navigate}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
            importBtnHandler={importBtnHandler}
            setCurrentPage={setCurrentPage}
            handleExportNpaProperties={handleExportNpaProperties}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onAddMapClick={() => setShowJantriModal(true)}
            title={nextLabel || "File"}
          // setSearchQuery={setSearchQuery}
          />

          {/* List Section */}
          <NpaListSection
            isEdit={isEdit}
            data={jantriList?.data}
            navigate={navigate}
            currentPage={currentPage}
            openDropdown={openDropdown}
            handleEditBtn={handleEditBtn}
            getCustomerActions={getCustomerActions}
            handleToggleDropdown={handleToggleDropdown}
            currentJantriType={currentJantriType}
            jantriList={jantriList}
            setSearchQuery={setSearchQuery}
            setFilterValues={setFilterValues}
            setSelectedItem={setSelectedItem}
            setShowEditModal={setShowEditModal}
            setIsViewOnly={setIsViewOnly}
            limit={limit?.value}
            isFileLevel={Boolean(isFileLevel)}
            setCurrentPage={setCurrentPage}
            searchQuery={searchQuery}
            filterValues={filterValues}
            isLoading={isLoading}
            isInitialLoad={isInitialLoad}
            pagination={paginationConfig}
          />
        </div>
      </Container>

      {/* Delete Modal */}
      <DeletePopup
        show={openDeletePropertyModal}
        onHide={() => setOpenDeletePropertyModal(false)}
        content="Are you sure you want to delete this Property?"
        removeTitle="Cancel"
        onConfirm={handleConfirmDelete}
        disabled={isSubmitting}
        saveTitle={isSubmitting ? "Deleting..." : "Delete"}
      />



      <ImportModal
        isOpen={openImportModal}
        onClose={() => setOpenImportModal(false)}
        users={importModalUsers}
        onSubmit={handleImportSubmit}
        title="Import Properties"
      />
      {/* <AddTpFileModal
        show={showTpModal}
        onHide={() => setShowTpModal(false)}
        title="New Co/Authority File"
        showDistrict={true}
        showTaluka={true}
        showCoAuthority={true}
        showAttachment={true}
      /> */}
      <AddStateModal
        isOpen={showJantriModal}
        onClose={() => {
          setShowJantriModal(false);
          setIsViewOnly(false);
        }}
        title={`${isViewOnly ? "View" : "Add"} ${nextLabel || "File"}`}
        rawTitle={nextLabel || "File"}
        isFileLevel={isFileLevel}
        isView={isViewOnly}

        keyboard={false}
        className="tp-file-modal"
        onSubmit={(payload) => {
          const action = isFileLevel
            ? createJantriFile({
              jantri_type_id: currentJantriType.id,
              location_id: jantriList?.parent_id || null,
              file: payload.file,
            })
            : createJantriLocation({
              jantri_type_id: currentJantriType.id,
              parent_id: jantriList?.parent_id || null,
              name: payload.name,
            });
          setLoading(true);
          return dispatch(action).then((res) => {
            setLoading(false);
            const success = res?.payload?.success;

            if (success) {
              toast.success(
                isFileLevel
                  ? "File added successfully"
                  : "Location added successfully",
              );

              setCurrentPage(1);

              dispatch(
                fetchJantriLocations({
                  jantri_type_id: currentJantriType.id,
                  parent_id: jantriList?.parent_id || null,
                  page: 1,
                  limit: limit?.value,
                  search: searchQuery || "",
                  direction: "forward",
                  mode: "auto",
                }),
              );
              setShowJantriModal(false);
            } else {
              toast.error(res?.payload?.message || "Failed to add");
              throw new Error(res?.payload?.message || "Failed to add");
            }
          }).catch((err) => {
            setLoading(false);
            throw err;
          });
        }}
      />

      <AddStateModal
        isOpen={showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setIsViewOnly(false);
        }}
        title={`${isViewOnly ? "View" : selectedItem ? "Update" : "Add"} ${nextLabel || "File"}`}
        rawTitle={nextLabel || "File"}
        isFileLevel={isFileLevel}
        isView={isViewOnly}
        defaultValue={selectedItem}

        keyboard={false}
        className="tp-file-modal"
        onSubmit={(payload) => {
          const action = isFileLevel
            ? updateJantriFile({
              id: selectedItem.id,
              file: payload.file,
            })
            : updateJantriLocation({
              id: selectedItem.id,
              name: payload.name,
            });
          setLoading(true);
          return dispatch(action).then((res) => {
            setLoading(false);
            const success = res?.payload?.success;

            if (success) {
              toast.success(
                isFileLevel
                  ? "File updated successfully"
                  : "Location updated successfully",
              );

              dispatch(
                fetchJantriLocations({
                  jantri_type_id: currentJantriType.id,
                  parent_id: jantriList?.parent_id || null,
                  page: currentPage,
                  limit: limit?.value,
                  search: searchQuery || "",
                  direction: "forward",
                  mode: "auto",
                }),
              );
              setShowEditModal(false);
            } else {
              toast.error(res?.payload?.message || "Update failed");
              throw new Error(res?.payload?.message || "Update failed");
            }
          }).catch((err) => {
            setLoading(false);
            throw err;
          });
        }}
      />
    </>
  );
}
